<article class="active-campaign-card">
  <header class="active-campaign-card__header">
    <h4 class="active-campaign-card__title">
      {{ title() }}
      @if (!loading() && totalAlertCount() > 0) {
        <span class="active-campaign-card__title-count">
          · {{ totalAlertCount() }} alert{{ totalAlertCount() === 1 ? '' : 's' }}
        </span>
      }
      @if (progressAttempt()) {
        <span class="active-campaign-card__title-attempt">
          · {{ progressAttempt() }}
        </span>
      }
    </h4>
  </header>

  @if (loading()) {
    <p class="active-campaign-card__loading">Loading campaign summary…</p>
  } @else if (timeline()) {
    <div class="active-campaign-card__timeline">
      <div class="active-campaign-card__timeline-labels">
        <span>{{ timeline()!.startLabel }}</span>
        <span>{{ timeline()!.endLabel }}</span>
      </div>
      <div class="active-campaign-card__track-wrap">
        <div class="active-campaign-card__track" aria-hidden="true">
          <div class="active-campaign-card__track-fill">
            @for (seg of visibleStatusSegments(); track seg.key) {
              <div
                class="active-campaign-card__status-seg"
                [class]="'active-campaign-card__status-seg--' + seg.key"
                [style.flex-grow]="statusSegmentFlex(seg)"
              ></div>
            }
          </div>
          @if (timeline()!.showNowMarker) {
            <div
              class="active-campaign-card__now-marker"
              [class.active-campaign-card__now-marker--label-left]="
                timeline()!.nowLabelAlign === 'left'
              "
              [class.active-campaign-card__now-marker--label-right]="
                timeline()!.nowLabelAlign === 'right'
              "
              [style.left.%]="timeline()!.nowPercent"
              [attr.aria-label]="'Now ' + timeline()!.nowLabel"
            >
              <span class="active-campaign-card__now-label" aria-hidden="true">
                <span class="active-campaign-card__now-word">Now</span
                ><span class="active-campaign-card__now-datetime">{{
                  timeline()!.nowLabel
                }}</span>
              </span>
            </div>
          }
          @for (dot of timeline()!.dots; track dot.index) {
            <div
              class="active-campaign-card__dot"
              [class.active-campaign-card__dot--done]="dot.done"
              [class.active-campaign-card__dot--next]="dot.isNext"
              [style.left.%]="dot.percent"
              [attr.title]="'Alert ' + (dot.index + 1) + ' of ' + scheduledSendCount()"
            ></div>
          }
        </div>
        @if (statusLabelAnchors().length > 0) {
          <div
            class="active-campaign-card__status-callouts"
            [style.min-height.px]="statusCalloutsMinHeight()"
          >
            @for (anchor of statusLabelAnchors(); track anchor.key) {
              <div
                class="active-campaign-card__status-callout"
                [class]="'active-campaign-card__status-callout--' + anchor.key"
                [style.left.%]="anchor.centerPercent"
                [style.--callout-row]="anchor.row"
              >
                <span class="active-campaign-card__status-callout-stem"></span>
                <span class="active-campaign-card__status-callout-text">
                  {{ anchor.percent }}% {{ anchor.label }}
                </span>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }

  <div class="active-campaign-card__footer">
    @if (group.campaignId && !hideHistoryLink) {
      <a
        class="active-campaign-card__history-link"
        [routerLink]="['/alerts']"
        [queryParams]="{ campaignId: group.campaignId, run: '1' }"
      >
        View in Alert History
      </a>
    }
    @if (noAlertWindowNote()) {
      <span class="active-campaign-card__window-note">
        <strong class="active-campaign-card__window-note-label">Note:</strong>
        {{ noAlertWindowNote() }}
      </span>
    }
    @if (campaignConfigDialogData()) {
      <button
        type="button"
        class="active-campaign-card__history-link active-campaign-card__config-link"
        [disabled]="loading()"
        (click)="openViewAlertConfiguration()"
      >
        View alert configuration
      </button>
    }
  </div>
</article>
